import React from "react";
import TwoColumnLayout from "../../layouts/TwoColumnLayout/TwoColumnLayout";

const ResourcesArchive = () => {
  return <TwoColumnLayout />;
};

export default ResourcesArchive;
